import { formatTimestamp } from '../../../utils/dates';

// Convierte un ApiError de /api/qr/* en un mensaje claro para quien escanea.
// Contrato: docs/CONTRATO-API-FASE2.md §10. Devuelve { title, message, hint? }.
//
// El backend responde el mismo 403 cuando el QR es de otra actividad y cuando
// al staff le quitaron el permiso hace un momento: no se distinguen, así que el
// mensaje cubre ambos y se muestra la lista actual de actividades asignadas.
export const describeQrError = (error, mode) => {
  const isStaff = mode === 'staff';
  const data = error.data || {};

  if (error.status === 403) {
    if (/rechazar/i.test(error.message)) {
      return {
        title: 'No puedes rechazar reservas',
        message: 'Solo la empresa puede rechazar una reserva. Puedes validarla o avisar al dueño.',
      };
    }
    if (isStaff) {
      return {
        title: 'Este QR es de otra actividad',
        message:
          'No tienes asignada la actividad de esta reserva, o tu permiso cambió hace un momento. ' +
          'No se cobró nada. Si te corresponde escanearla, pide a la empresa que te la asigne.',
        hint: 'staff-activities',
      };
    }
    return {
      title: 'Este QR no es de tu empresa',
      message: 'Esta reserva pertenece a otra empresa. No se cobró nada.',
    };
  }

  if (error.status === 404) {
    return {
      title: 'Reserva no encontrada',
      message: 'Este código no corresponde a ninguna reserva. Puede haberse eliminado.',
    };
  }

  if (error.status === 429) {
    return {
      title: 'Demasiados intentos',
      message: 'Espera un momento antes de escanear de nuevo.',
    };
  }

  if (error.status === 400) {
    if (data.scannedAt) {
      return {
        title: 'Este QR ya fue usado',
        message:
          `Se escaneó el ${formatTimestamp(data.scannedAt)}` +
          (data.scannedBy ? ` por ${data.scannedBy}` : '') +
          '. No se puede validar otra vez.',
      };
    }
    if (/^QR inválido/i.test(error.message)) {
      return {
        title: 'Código QR no válido',
        message: 'El código está alterado o no es de BokerHub. No se hizo ningún cobro.',
      };
    }
    return { title: 'No se puede validar esta reserva', message: error.message };
  }

  if (error.status >= 500) {
    return {
      title: 'Error del servidor',
      message: 'No se pudo completar la operación. No se cambió nada; inténtalo de nuevo.',
    };
  }

  return { title: 'No se pudo completar', message: error.message };
};
